/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'eye': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(7 11)" _stroke="#00272E"><path pid="0" d="M17.625 5.5S13.764 10.607 9 10.607C4.236 10.607.375 5.5.375 5.5S4.236.393 9 .393c4.764 0 8.625 5.107 8.625 5.107z"/><ellipse pid="1" cx="9" cy="5.5" rx="3" ry="3.143"/><path pid="2" d="M9 3.929c.828 0 1.5.703 1.5 1.571S9.828 7.071 9 7.071 7.5 6.368 7.5 5.5"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/eye.js